import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import FuelPriceOutputComponent from '../output/FuelPriceOutputComponent';

const FuelPriceInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-dollar', title: 'Fuel Price', subtitle: 'Fetch latest fuel prices for a state' }}
        fields={[
            { name: 'state', label: 'State', icon: 'pi-map-marker', placeholder: 'e.g. kerala', maxLength: 50, lowercase: true,
              colClass: 'col-12 md:col-6 lg:col-4' },
        ]}
        endpoint={{
            path: '/surepass/utilities/fuel-price',
            bodyMapper: (v, sid) => ({ state: v.state.trim(), api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="fuel-price"
        submitLabel="Fetch Fuel Price"
        successSummary="Fuel price fetched"
        errorSummary="Fuel price fetch failed"
        confirmHeader="Confirm fuel price fetch"
        confirmAcceptLabel="Yes, fetch"
        outputComponent={FuelPriceOutputComponent}
    />
);

export default FuelPriceInputComponent;
